import loadable from '@loadable/component';

export const NewbuildingBrokerCallbackWidgetAdapterLoadable = loadable(
  () => import('./NewbuildingBrokerCallbackWidgetAdapter'),
  {
    resolveComponent: ({ NewbuildingBrokerCallbackWidgetAdapter }) => NewbuildingBrokerCallbackWidgetAdapter,
    ssr: false,
  },
);
